











import { defineComponent } from '@nuxtjs/composition-api';
import VaimoHeading from 'atoms/VaimoHeading.vue';

import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'CategoryHeading',
  components: {
    VaimoHeading,
    SkeletonLoader
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      required: false,
      default: 'h1',
      validator: (value: string) =>
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
    }
  }
});
